import React from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'

import { noop } from 'constants/global'

import { Form } from 'components'

interface AgreementFormValues {
  value: string
}

interface AgreementProps {
  disabled: boolean
  onSubmit: (value: string) => void
}

type FinalProps = InjectedFormProps<AgreementFormValues, AgreementProps>
  & AgreementProps

const AGREEMENT_FORM = 'agreement'

const toolbarOptions = {
  // eslint-disable-next-line camelcase
  content_style: 'body { font-family: Figtree, sans-serif; }',
  // eslint-disable-next-line max-len
  toolbar: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
}

const Agreement: React.FC<FinalProps> = ({ disabled, onSubmit }) => {
  const handleBlur = (e) => {
    onSubmit(e.target.getContent() || ' ')
  }

  return (
    <Form onSubmit={noop}>
      <Field
        component={Form.TextEditorField}
        disabled={disabled}
        extraOptions={toolbarOptions}
        name="value"
        onBlur={handleBlur}
      />
    </Form>
  )
}

export default (
  reduxForm<AgreementFormValues, AgreementProps>({ form: AGREEMENT_FORM })(Agreement)
)
